import { Component } from "react"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Redux */
import { connect } from "react-redux"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"

/* Constants */
import { games } from "../../constants"

/* Swal */
import Swal from "sweetalert2"

/* Components */
import { Input } from "../../components"

/* REST API */
import { create } from "../../api/Game"

/* Switch */
import Switch from "react-switch"


/* Page Create Game */
class CreateGame extends Component {

    constructor() {
        super()

        this.state = {
            status: false,
            waiting: false,

            name: "",
            slug: "",
            game: "",
            gameURL: "",
            backURL: "",
            room: "",
            visible: false,
        }
    }


    /* Save action */
    save = () => {

        const { name, slug, game, gameURL, backURL, visible, room } = this.state
        const { navigate } = this.props

        if (name === "") {
            this._name.error(t("game.error.emptyName"))
            return
        }

        if (slug === "") {
            this._slug.error(t("game.error.emptyKey"))
            return
        }

        if (/[^a-z0-9-]/i.test(slug)) {
            this._slug.error(t("game.error.invalidKey"))
            return
        }

        if (game === "") {
            Swal.fire(utils.notification(t("game.error.selectGame"), "error"))
            return
        }

        this.setState({ waiting: true })

        create({ name, slug, game, gameURL, backURL, visible, room }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("game.addedSuccess"), "success")).then(() => {
                    this.setState({ waiting: false })
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ waiting: false })
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                this.setState({ waiting: false })
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                this.setState({ waiting: false })
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            this.setState({ waiting: false })
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        })

    }


    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        /* Fields */
        const { name, slug, game, gameURL, backURL, visible, room } = this.state

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("game.addTitle")}</h1>
                </div>

                <div className="page-form">
                    <div className="form">
                        <div className="form-box">

                            <Input ref={(ref) => this._name = ref} label={t("game.tableName")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                            <Input ref={(ref) => this._slug = ref} label={t("game.tableKey")} value={slug} onChange={(event) => this.setState({ slug: event.target.value })} />

                            <select value={game} onChange={(event) => this.setState({ game: event.target.value })}>
                                <option disabled value="">{t("game.selectGame")}</option>
                                {games.data.map((item, index) => <option key={`${index}`} value={item.key}>{item.name}</option>)}
                            </select>

                            <Input ref={(ref) => this._gameURL = ref} label={t("game.gameURL")} value={gameURL} onChange={(event) => this.setState({ gameURL: event.target.value })} />
                            <Input ref={(ref) => this._backURL = ref} label={t("game.serverURL")} value={backURL} onChange={(event) => this.setState({ backURL: event.target.value })} />
                            <Input ref={(ref) => this._backURL = ref} label="Room" value={room} onChange={(event) => this.setState({ room: event.target.value })} />

                            <div className="form-status-title">{t("game.tableStatuses")}</div>

                            <div className="form-switch">
                                <span>{t("game.tableVisibility")}</span>
                                <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ visible: value })} checked={visible} />
                            </div>

                        </div>

                    </div>

                    <div className="form-bottom form-bottom-full">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default withRouter(connect(mapStateToProps)(CreateGame))